import React from 'react';
import { LoginIllustration } from './LoginIllustration';

interface TabletLayoutProps {
  FormComponent: React.ComponentType;
}

export function TabletLayout({ FormComponent }: TabletLayoutProps) {
  return (
    <div className="flex flex-col w-full h-screen overflow-hidden bg-white items-center justify-center">
      {/* Top: gradient illustration panel with the logo in its top-left corner */}
      <div className="flex flex-1 flex-col items-center  w-full h-full overflow-auto">
        <div className="sticky top-0 z-10 flex w-full shrink-0 flex-col items-center bg-white mb-[56px]">
          <LoginIllustration
            className="w-full h-[45vh]"
            width="min(54%, 36vh)"
          />
          {/* Viewport units (Figma left 40 / top 40 / height 64px on 834×1194)
              so zoom does not resize or move the logo, matching the
              illustration */}
          <img
            src="/pozytronLogo.svg"
            alt="Pozytron"
            className="absolute left-[4.796vw] top-[3.35vh] h-[5.36vh] w-auto"
          />
        </div>

        {/* Form (Forgot Password / Login / etc.) */}
        <div className="flex flex-col items-start justify-center w-[60%] gap-[48px] ">
          <FormComponent />
        </div>
      </div>

      <p className="w-full mx-auto px-6 pb-6 pt-6 text-bodyMedium text-on-surface-variant text-center">
        © 2025 Pozytron Radiologia Medyczna sp. z o. o. Wszelkie prawa
        zastrzeżone.
      </p>
    </div>
  );
}
